import React, { Fragment, memo, useEffect, useMemo } from "react";
import { Box, Button, Card, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import VisionListing from "Modules/Vision/Listing/Cards";
import GoodJobDone from "../GoodJobDone";
import useStyles from "./styles";
import VisionCarousel from "../../../components/SkeletonLoader/VisionCarousel";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { loggedInUserDetails } from "Recoil/LoggedInUserDetail/selector";
import { useDashboard } from "Hooks/dashboard/useDashboard";
import { useFormContext, useWatch } from "react-hook-form";
import { getCompanyId, getUserId } from "src/utils";
import { get } from "lodash";
import { Link, useHistory } from "react-router-dom";
import { BOARD, VISION } from "src/constants/routeConstants";
import { visionCardsData } from "Recoil/Vision/atom";
import EmptyWidget from "../EmptyWidget";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
// import VisionListKpi from "Modules/SuccessStory/PreviewSuccessStory/KpiList/CoacheeKpiDetails/VisionListKpi";

// {
//   dashboardLoading,
//   remainingVisionCount,
//   visionList,
//   refetchVisions,
// }
const VisionWidget = () => {
  const classes = useStyles();
  let _loggedInUser = useRecoilValue(loggedInUserDetails);
  const methods = useFormContext();
  const { vision } = useWatch({ name: "loader" });
  const { remainingVisionCount, visionList } = useWatch({ name: "visions" });
  const setCardListDisplay = useSetRecoilState(visionCardsData);
  const cardListDisplay = useRecoilValue(visionCardsData);
  const { visionDetails } = useDashboard({ methods });
  const { t } = useTranslation();
  const history=useHistory();
  const userId = getUserId();
  const companyId = getCompanyId();
  const responsive = {
    0: { items: 1 },
    600: { items: 2 },
    1024: { items: 3 },
  };

  const fetchVisionData = () => {
    if (userId && companyId) {
      const variables = {
        id: userId,
        companyId,
        visionType: "UserDashboard",
        userId,
      };
      methods?.setValue("loader.vision", true);
      visionDetails({ variables });
    }
  };

  useEffect(() => {
    fetchVisionData();
  }, []);
  const displayEmptyWidget = useMemo(
    () => (
      <EmptyWidget
        pendoId="vision"
        type={"visions"}
        title="Community visions"
        desc="Craft a forward-looking vision that motivates you, your colleagues, and/or your organization to collectively strive toward a shared and inspiring future."
        showClose={
          (visionList || []).length && !_loggedInUser?.overlayStatus?.visions
        }
      />
    ),
    [(visionList || []).length && !_loggedInUser?.overlayStatus?.visions]
  );
  return (
    <>
      {vision ? (
        <Card className={classes.widgetCard}>
          <Skeleton height="10px" width="25%" />
          <Box height="270px" mt={2}>
            <VisionCarousel />
          </Box>
          <Box textAlign="center" mt={3.4}>
            <Skeleton height="20px" width="100px" />
          </Box>
        </Card>
      ) : (
        <Card
          className={`${classes.widgetCard} ${
            (visionList || []).length && _loggedInUser?.overlayStatus?.visions
              ? ""
              : classes.emptyWidgetClass
          }`}
        >
          {(visionList || []).length ? (
            // <VisionListKpi kpiDetails={cardListDisplay} number={3} />
            <Fragment>
              {_loggedInUser?.overlayStatus?.visions
                ? null
                : displayEmptyWidget}

              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography
                  variant="body1"
                  className="font-bold font-13 widget-title"
                >
                  Community visions
                </Typography>
              </Box>
              <Box className={classes.visionCarousel}>
                <VisionListing
                  remainingVisionCount={remainingVisionCount}
                  responsive={responsive}
                  visions={cardListDisplay}
                  listingType="Carousel"
                  refetchVisions={() => fetchVisionData()}
                  isFromDashboard={true}
                  setCardListDisplay={setCardListDisplay}
                  // toastMessageForDashboard={toastMessageForDashboard}
                />
              </Box>
              <Box
                className={`${classes.divider} action-btn`}
                display="flex"
                justifyContent="center"
              >
                <Button onClick={() => history.push(VISION + BOARD)} className={classes.viewAllBtn}>
                  All visions
                </Button>
              </Box>
            </Fragment>
          ) : (
            // <Box className={classes.emptyState} height="80%">
            //   <GoodJobDone
            //     label={t("dashboard.noVision")}
            //     content={true}
            //     darkTheme={true}
            //     type={"vision"}
            //   />
            // </Box>
            displayEmptyWidget
          )}
        </Card>
      )}
    </>
  );
};

export default memo(VisionWidget);
